import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { getFilteredWatchlists, getModelId, getSearchValue, getSelectedWatchlists, getSupportsRestoringDeleting, getDefaultSelectedWatchlists, getApplyButtonEnabled, getSecurity, getAsOf } from "./selectors"

export default createModule({
  view,
  externalProps: state => ({
    account: state.global.selected.account,
  }),
  required: ["account"],
  data: [{
    resource: "watchlists",
    as: null,
    url: () => ({
      id: "watchlists",
      query: "query { watchlists { id, name } }",
    }),
  }],
  mapStateToProps: (state, props) => ({
    watchlists: getFilteredWatchlists(state, props),
    searchValue: getSearchValue(state),
    selectedWatchlists: getSelectedWatchlists(state, props),
    supportsRestoringDeleting: getSupportsRestoringDeleting(state, props),
    defaultSelectedWatchlists: getDefaultSelectedWatchlists(state, props),
    security: getSecurity(state, props),
    asOf: getAsOf(state, props),
    modelId: getModelId(state, props),
    applyButtonEnabled: getApplyButtonEnabled(state, props),
    updated: state.modules.watchlistsMenu.updated,
    creatingWatchlist: state.modules.watchlistsMenu.creatingWatchlist,
  }),
  actions: {
    ...Creators,
  },
})
